import React from "react";
import { motion } from "framer-motion";
import { Target, Eye } from "lucide-react";
import { FOUNDERS, Reveal } from "../../lib/site";

export const Founders = () => {
  return (
    <section id="founders" data-testid="founders-section" className="bg-navy py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <span className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-gold">
            05 — Founders
          </span>
          <h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-white max-w-2xl text-balance">
            Founded with a vision to become a trusted international trading partner
          </h2>
          <p className="mt-6 max-w-2xl text-slate-300 leading-relaxed">
            AM Ventures was founded by Parth Ahuja and Kartik Mundeja, driven by a shared focus on global
            sourcing, quality, reliability and customer satisfaction.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-8 md:grid-cols-2">
          {FOUNDERS.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.76, 0, 0.24, 1] }}
              data-testid={`founder-card-${i}`}
              className="group overflow-hidden rounded-3xl border border-white/10 bg-navy-tint"
            >
              <div className="relative overflow-hidden bg-white">
                <img
                  src={f.img}
                  alt={f.name}
                  className="h-[420px] w-full object-cover object-top grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1F3A]/40 to-transparent" />
              </div>
              <div className="p-8">
                <div className="flex items-baseline justify-between">
                  <h3 className="font-display text-2xl font-semibold text-white">{f.name}</h3>
                  <span className="text-sm uppercase tracking-[0.2em] text-gold">{f.role}</span>
                </div>
                <p className="mt-4 text-slate-300 leading-relaxed">{f.bio}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const MissionVision = () => {
  const cards = [
    {
      icon: Target,
      tag: "Mission",
      text: "To deliver quality products and dependable sourcing solutions that empower our partners to grow with confidence across global markets.",
    },
    {
      icon: Eye,
      tag: "Vision",
      text: "To become a globally recognized trading company built on trust, transparency and professionalism at every level of trade.",
    },
  ];
  return (
    <section data-testid="mission-vision-section" className="bg-navy-deep py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid gap-8 md:grid-cols-2">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal key={c.tag} delay={i}>
              <div
                data-testid={`mv-card-${c.tag.toLowerCase()}`}
                className="relative h-full overflow-hidden rounded-3xl border border-white/10 bg-navy p-10 md:p-12 grain"
              >
                <span className="grid h-14 w-14 place-items-center rounded-2xl bg-gold/10 text-gold">
                  <Icon size={26} />
                </span>
                <h3 className="mt-8 font-display text-3xl md:text-4xl font-light text-white">
                  Our <span className="text-gold">{c.tag}</span>
                </h3>
                <p className="mt-5 text-lg text-slate-200 leading-relaxed text-balance">{c.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
